import React from 'react'
import { withRouter } from 'react-router-dom'
import { Header, Container, Wrapper } from '../../components_renew/Layout'
import bgImg from '../../assets/xiniu/user_trans/bg.jpg'
import { postMessage } from '../../utils'

@withRouter
class XiniuUserTrans extends React.Component {
  componentDidMount () {
    document.title = '更名通知'
  }

  render () {
    const { withHeader } = this.props
    return <Container>
      {withHeader ? <Header>更名通知</Header> : null}
      <Wrapper>
        <img className={''}
             src={bgImg}
             alt=""
             onClick={this.onClick}
        />
      </Wrapper>
    </Container>
  }

  onClick = () => {
    postMessage({
      type: window.POST_TYPE.DOWNLOAD,
      data: 'https://cdn.hnqcwlkj.com/app-x_appupdate-release.apk'
    })
    // postMessage({ type: 'download' })
  }
}

export default XiniuUserTrans